import React from 'react';
import classNames from 'classnames';

import css from './IconHotelLaundry.module.css';

/**
 * IconHotelLaundry icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconHotelLaundry = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M0 2.14286C0 0.95939 0.959386 0 2.14286 0H15C16.1834 0 17.1429 0.95939 17.1429 2.14286V3.54457H0V2.14286ZM0 5.33029V17.8571C0 19.0406 0.959386 20 2.14286 20H15C16.1834 20 17.1429 19.0406 17.1429 17.8571V5.33029H0ZM3.41784 12.1428C3.41784 11.8579 3.44107 11.5778 3.48583 11.3046C3.4879 11.2905 3.49027 11.2765 3.4929 11.2626C3.54249 10.9749 3.61597 10.695 3.71136 10.4251C4.41833 8.42489 6.32583 6.98927 8.5714 6.98927C11.4176 6.98927 13.725 9.2966 13.725 12.1428C13.725 14.989 11.4176 17.2964 8.5714 17.2964C5.72517 17.2964 3.41784 14.989 3.41784 12.1428ZM5.00324 11.715C5.06096 11.3709 5.3588 11.1189 5.70769 11.1189H6.21317C7.30553 11.1189 7.94597 11.3853 8.52173 11.6249L8.60766 11.6606C9.14616 11.8836 9.68974 12.0937 10.766 12.0937H11.4756C11.6857 12.0937 11.8852 12.1862 12.0209 12.3465C12.1566 12.5069 12.2148 12.7189 12.1801 12.9261C11.8913 14.6476 10.3953 15.9593 8.59166 15.9593C6.58206 15.9593 4.95296 14.3301 4.95296 12.3205C4.95296 12.1147 4.97012 11.9124 5.00324 11.715Z" fill="#262338"/>
</svg>



  );
};

export default IconHotelLaundry;
